import EFPicture from 'elem/compCommon/EFPicture';
import PortableDesign from '@elem/SVGIcon/VanlifeRoadtrips/PortableDesign';
import PlugAndPlay from '@elem/SVGIcon/PowerBackup/PlugAndPlay';
import Battery from '@elem/SVGIcon/VanlifeRoadtrips/Battery';
import css from './index.module.scss';
import { useGlobal } from '@/utils/useGlobal';

export default function J_NA() {
    const { useLang, useRouter } = useGlobal();
    const { locale } = useRouter();
    const { t } = useLang('outdoorrecreation');
    const icons: any = [
        {
            icon: <Battery />,
            text: t('secJ_tag1'),
        },
        {
            icon: <PlugAndPlay className="color" />,
            text: t('secJ_tag2'),
        },
        {
            icon: <PortableDesign />,
            text: t('secJ_tag3'),
        },
    ];
    const img: any = {
        us: ['/responsive/picture/outdoor-recreation/9_na.jpg', '/responsive/picture/outdoor-recreation/9_375_na.jpg'],
        ca: ['/responsive/picture/outdoor-recreation/9_na.jpg', '/responsive/picture/outdoor-recreation/9_375_na.jpg'],
        za: ['/responsive/picture/outdoor-recreation/9_za.png', '/responsive/picture/outdoor-recreation/9_za_768.png'],
    };

    // if (['us', 'ca'].includes(locale)) return null;

    return (
        <div id="outdoor-recreation-J" className={`outdoor-recreation-J ${css['outdoor-recreation-J']}`}>
            <div className="img-box">
                <EFPicture src={img[locale][0] || img['us'][0]} srcMobile={img[locale][1] || img['us'][1]} alt={t('secJ_title')} />
                <div className="text-content">
                    <p className="title">{t('secJ_title')}</p>
                    <p className="desc">{t('secJ_desc')}</p>
                    <ul className="icons">
                        {icons?.map((icon: any) => (
                            <li className="icon-item" key={icon?.text}>
                                {icon?.icon}
                                <p className="icon-text">{icon?.text}</p>
                            </li>
                        ))}
                    </ul>
                </div>
            </div>
        </div>
    );
}
